module.exports = __webpack_public_path__ + "img/icon-visa.14bf2780.svg";